import React, { useEffect } from 'react'
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-regular-svg-icons";
import { FaStar } from "react-icons/fa";
import Rating from '../common/Rating';



const NewStoreCard = ({createPopUp,flyToStore,storeData,REF}) => {
        const handleGoToLocation = ()=>{
          flyToStore(storeData);
          createPopUp(storeData);
        }
        const altImag = `https://th.bing.com/th/id/OIP.vg49Rg4lf-bVtcQjHxlJkgHaHa?rs=1&pid=ImgDetMain`
  return (
    <div ref={REF} onMouseOver={handleGoToLocation} className=" p-2 mb-2 bg-white rounded-xl transform transition-all hover:-translate-y-2 duration-300 shadow-lg hover:shadow-2xl flex flex-col justify-between">
     <Link  to={`/?path=description&ID=${storeData.id}&type=store`}>
    <img className="w-[100%] skeleton h-40 object-cover rounded-xl" src={storeData?.images && storeData?.images.length>0?storeData?.images[0]?.image:altImag}
    alt={storeData.name}/>
    <div className="p-2">

    <h2 className="font-bold text-lg mb-2 line-clamp-4">{storeData.name}</h2>
    <div className="mt-2 flex">
                {/* <div className="">
                <p className="text-lg truncate text-gray-400 mr-2">{storeData.category}</p>
                </div> */}
                {/* <span className="text-lg truncate text-gray-400 mr-2">&bull;</span> */}
            {
              storeData.category =="Restaurant" && <> <div className="">
              <p className="text-lg truncate text-gray-400 mr-2">$$</p>
              </div>
               <span className="text-lg truncate text-gray-400 mr-2">&bull;</span>
               </>
            } 
                <div className="mr-2 flex">
              {
                storeData.rating &&  <span className="text-lg truncate text-gray-400 mr-2">{storeData.rating} </span>
              }
                <div className="mr-2 flex items-center">
              {
               storeData?.rating &&   <Rating rating={storeData?.rating} />
              }
                </div>
                {
              (storeData?.reviews_count!=0  &&  storeData?.reviews_count) && <span className="text-lg truncate text-gray-400 mr-2">({storeData?.reviews_count})</span>
                }
                </div>
               </div>

    <p className="text-sm text-gray-600 line-clamp-4">{storeData?.description}</p>
    </div>
{/*  
    <div className="m-2">
    <Link role='button' to={`/?path=description&ID=${storeData.id}&type=place`} class="text-white bg-purple-600 px-3 py-1 rounded-md hover:bg-purple-700">View More</Link>
    </div> */}
   </Link>
  </div>
  )
}


export default NewStoreCard
